import CustomBox from "../../components/CustomBox";
import CustomScrollCalendar from "../../components/CustomScrollCalendar";
import { useContext, useState } from "react";
import "./AppointmentPage.css";
import { useBookAppointment } from "../../services/api/services";
import { AppointmentBody } from "../../models/AppointmentBody"; // if stored separately
import { BaseAppContext } from "../../utils/context";
import LoadingPanel from "../../components/LoadingPanel";

function AppointmentPage() {
  const morningTime = ["10:00 - 11:00", "11:00 - 12:00", "12:00 - 01:00"];
  const eveningTime = ["02:00 - 03:00", "03:00 - 04:00", "04:00 - 05:00"];
  const { loggedPatientId } = useContext(BaseAppContext);
  const [bookAppointmentState, bookAppointment] = useBookAppointment();

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedSlot, setSelectedSlot] = useState<string | null>(null);

  const handleDateSelect = (date: Date | null): void => {
    console.log("date", date);
    setSelectedDate(date);
  };

  const handleSlotSelect = (time: string | null): void => {
    setSelectedSlot(time);
  };

  const handleSubmit = () => {
    if (!selectedDate || !selectedSlot) {
      alert("Please select both date and time slot.");
      return;
    }

    const formattedDate = new Intl.DateTimeFormat("en-CA").format(selectedDate); // "2025-05-11"
    const formattedTime = selectedSlot.split(" - ")[0]; // "11:00"

    const appointment: AppointmentBody = {
      doctorId: 1,
      patientId: parseInt(loggedPatientId),
      appointmentDate: formattedDate,
      appointmentTime: formattedTime,
    };

    bookAppointment(appointment);
  };

  return (
    <>
      {bookAppointmentState?.loading && (
        <LoadingPanel fullScreen message="Loading..." />
      )}
      <div className="appointment-container">
        <div className="calendar-section">
          <CustomScrollCalendar onDateSelect={handleDateSelect} />
        </div>

        <div className="slots-section">
          <div className="slot-group">
            <h4>Morning</h4>
            <p className="slot-time-range">09:00 AM to 12:00 PM</p>
            <CustomBox
              timeSlots={morningTime}
              onSlotSelect={handleSlotSelect}
            />
          </div>

          <div className="slot-group">
            <h4>Evening</h4>
            <p className="slot-time-range">02:00 PM to 05:00 PM</p>
            <CustomBox
              timeSlots={eveningTime}
              onSlotSelect={handleSlotSelect}
            />
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-primary" onClick={handleSubmit}>
            Book Appointment
          </button>
        </div>
      </div>
    </>
  );
}

export default AppointmentPage;
